<template>
  <div class="top">
    <div class="title">微页</div>
    <div class="h-flex">
      <el-menu
          :default-active="index"
          class="el-menu-demo" mode="horizontal"
          @select="handleSelect" background-color="#5dbb85" text-color="#fff" active-text-color="#ffd04b"
          unique-opened="true" router="true" v-if="user.login_type=='company'">
        <el-menu-item index="index_user">首页管理</el-menu-item>
        <el-submenu index="1">
          <template slot="title">账号管理</template>
          <el-menu-item index="company_admin">登陆管理</el-menu-item>
          <el-menu-item index="company_mine">个人信息</el-menu-item>
        </el-submenu>
<!--        <el-menu-item index="company_admin">登陆管理</el-menu-item>-->
        <el-menu-item index="company_page_sort">单页分类</el-menu-item>
        <el-menu-item index="company_page_list">单页管理</el-menu-item>
        <el-menu-item index="company_ebook_list">电子书管理</el-menu-item>
        <el-submenu index="2">
          <template slot="title">充值升级</template>
          <el-menu-item index="company_recharge">充值管理</el-menu-item>
          <el-menu-item index="vip">购买套餐</el-menu-item>
          <el-menu-item index="media">购买容量</el-menu-item>
          <el-menu-item index="company_send">分配记录</el-menu-item>
        </el-submenu>
<!--        <el-menu-item index="company_recharge">充值管理</el-menu-item>-->
<!--        <el-menu-item index="company_send">分配记录</el-menu-item>-->
<!--        <el-menu-item index="vip">升级VIP</el-menu-item>-->
      </el-menu>
    </div>
    <div>{{user.realname}}
      <span class="iconfont icon-VIP" style="color: gold;margin-left: 5px;font-size: 18px" v-if="user.is_vip>0"></span>
    </div>
    <div class="ml-10" v-if="user.use_num">可分配次数：{{user.use_num}}</div>
    <div style="margin-left:20px;cursor: pointer;" @click="reload">刷新</div>
    <div class="button">
      <div class="button-exit" @click="header_exit">退出</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "header",
  data() {
    return {
      index: ''
    };
  },
  methods:{
    header_exit : function (){
      this.$_vueVuex('is_login',false);
      this.$_vueVuex('user',{});
      this.$router.replace('/');
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    reload:async function (){
      this.$_showLoading();
      let res = await this.$_api.login('getuserinfo', {uid:this.user.uid});
      if(res.errcode == 0){
        this.$_showToast(res.errmsg,res.style);
        this.$_vueVuex('user',res.user);
        this.$_hideLoading();
      }
    }
  }
}
</script>

<style scoped>
.top { height: 60px; line-height: 60px; overflow: hidden; display: flex; flex: 1;background: #5dbb85;}
.title { font-size: 24px; width: 180px;}
.h-flex { flex: 1;}
.button { padding: 0 10px; display: flex; }
.button-exit { padding: 0 20px; font-size: 14px; cursor: pointer; }
</style>